import { type TypeBackground } from "@mui/material";

export const backgroundLight: Partial<TypeBackground> = {
  default: "#fafafa",
};
